import { render, staticRenderFns } from "./RiChang1.vue?vue&type=template&id=99d46e6c&scoped=true&"
import script from "./RiChang1.vue?vue&type=script&lang=js&"
export * from "./RiChang1.vue?vue&type=script&lang=js&"
import style0 from "./RiChang1.vue?vue&type=style&index=0&id=99d46e6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d46e6c",
  null
  
)

export default component.exports